module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.haveInvoice) ? _c('div', [_c('ul', {
    staticClass: "nav nav-actions"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.urlToDownloadPdf
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadFile($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Download PDF")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.urlToDownloadArchive,
      "id": "download-archive"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadFile($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-archive-o"
  }), _vm._v(" Download Weighbridge Archive")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-flex"
  }, [_c('div', {
    staticClass: "ibox ibox-flex"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('ul', {
    staticClass: "invoice-details"
  }, [_c('li', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v("\n                " + _vm._s(_vm.decorated.user_name)), _c('br'), _vm._v("\n                " + _vm._s(_vm.decorated.user_address)), _c('br'), _vm._v("\n                " + _vm._s(_vm.decorated.user_suburb) + ", " + _vm._s(_vm.decorated.user_state) + ", " + _vm._s(_vm.decorated.user_postcode) + ","), _c('br'), _vm._v("\n                Australia\n              ")])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v(_vm._s(_vm.decorated.xero_number))])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v(_vm._s(_vm.decorated.order_reference))])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v(_vm._s(_vm.decorated.created_date_alternative))])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v(_vm._s(_vm.decorated.due_date_alternative))])])])])])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('h3', {
    staticClass: "invoice-single"
  }, [_vm._v("Invoice Items")]), _vm._v(" "), _c('ul', {
    staticClass: "list-detail list-detail-invoice-single"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'jobs.show',
        params: {
          id: _vm.invoice.job.id
        }
      }
    }
  }, [_vm._v("\n            Job " + _vm._s(_vm.decorated.job.number) + "\n          ")]), _vm._v(" "), _vm._l((_vm.invoice.loads), function(load) {
    return _vm._l((load.items), function(item) {
      return _c('invoice-invoiced-item', {
        key: ("load-" + (load.id) + "-item-" + (item.id)),
        attrs: {
          "item": item,
          "load": load,
          "user": _vm.invoice.user
        }
      })
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-offset-3 col-xs-9 col-sm-offset-7 col-sm-5 col-lg-offset-8 col-lg-4"
  }, [_c('ul', {
    staticClass: "invoice-totals"
  }, [_c('li', [_vm._v("\n              Subtotal\n              "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.decorated.total_without_gst))])]), _vm._v(" "), _c('li', [_vm._v("\n              Total GST (10%)\n              "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.decorated.total_gst))])]), _vm._v(" "), _c('li', {
    staticClass: "total"
  }, [_vm._v("\n              Total AUD\n              "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.decorated.total_with_gst))])]), _vm._v(" "), (_vm.decorated.hasSomePayments) ? _c('li', [_vm._v("\n              Payments\n              "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.decorated.paid))])]) : _vm._e(), _vm._v(" "), (_vm.decorated.hasSomePayments) ? _c('li', {
    staticClass: "total"
  }, [_vm._v("\n              Amount Due AUD\n              "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.decorated.remaining))])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('h3', {
    staticClass: "invoice-single"
  }, [_vm._v("Payment History")]), _vm._v(" "), _c('ul', {
    staticClass: "list-detail list-detail-payments"
  }, [_vm._l((_vm.invoice.payments), function(payment) {
    return _c('invoice-payment-item', {
      key: payment.id,
      attrs: {
        "payment": payment
      }
    })
  }), _vm._v(" "), (_vm.haveNoInvoicePayments) ? _c('li', {
    staticClass: "text-center text-muted"
  }, [_vm._v("\n          There are no payments.\n        ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-offset-3 col-xs-9 col-sm-offset-7 col-sm-5 col-lg-offset-8 col-lg-4"
  }, [_c('ul', {
    staticClass: "invoice-totals"
  }, [_c('li', {
    staticClass: "total"
  }, [_vm._v("\n              Total\n              "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.totalOfPaymentsAsMoney))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-12"
  }, [_c('ladda-button', {
    staticClass: "btn btn-sm btn-warning pull-right",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "on-click": _vm.handleSyncToXero
    }
  }, [_vm._v("Sync To Xero")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('h2', [_vm._v("Payment Methods")]), _vm._v(" "), _vm._m(6)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("To:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Invoice:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Reference:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Issued:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Due:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox ibox-flex"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('ul', {
    staticClass: "invoice-details"
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("From:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v("\n                Arrow Logistics (QLD) Pty Ltd"), _c('br'), _vm._v("\n                ATF Forster & Borrman Trust"), _c('br'), _vm._v("\n                PO Box 4796"), _c('br'), _vm._v("\n                Toowoomba East QLD 4350"), _c('br')])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("ABN:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v("52 559 308 952")])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("ACN:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v("119 008 454")])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Office:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v("0455 123 172")])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Office:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v("accounts@arrowlogistics.com.au")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "m-b-lg"
  }, [_c('strong', [_c('i', {
    staticClass: "far fa-university"
  }), _vm._v(" Bank Transfer")]), _c('br'), _vm._v("\n    BSB: 064 446"), _c('br'), _vm._v("\n    Account: 1022 6813"), _c('br'), _vm._v("\n    Name: ARROW LOGISTICS\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-161104f4"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoices/Show.vue
// module id = 937
// module chunks = 0